<template>
  <el-container>
    <el-main style="padding: 0; width: 100vh">
      <vm-table
          ref="vmTable"
          module="basic"
          :url="'customerDeliveryAddress?customerId=' + mainId"
          :is-height="false"
          @select="selectHandle"
          @select-all="selectHandle">
        <div slot="toolbar">
          <el-button type="primary" @click="$refs.customerAddressModal.open(0, mainId)"> 新建 </el-button>
          <el-button v-if="selection.length > 0" type="danger" @click="deleteBatch">批量删除</el-button>
        </div>
        <el-table-column type="selection" align="center" width="55" prop="selection"/>
        <el-table-column
            type="index"
            label="#"
            align="center"
            width="55"
            prop="index"/>
        <el-table-column prop="addressName" align="left" label="所在区域"/>
        <el-table-column prop="addressDetail" align="left" label="详细地址"/>
        <el-table-column prop="isDefault" align="center" width="100" label="是否默认地址">
          <template slot-scope="scope">
            <el-tag>
              {{scope.row.isDefault ? "是" : "否"}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="contact" align="center" width="80" label="联系人"/>
        <el-table-column prop="telephone" align="center" width="120" label="联系方式"/>
        <el-table-column label="操作" align="center" width="120px" prop="action">
          <template slot-scope="scope">
            <el-button type="primary" @click="$refs.customerAddressModal.open(scope.row.pkid)">编辑</el-button>
            <el-button type="danger" @click="oneDelete(scope.row.pkid)">删除</el-button>
          </template>
        </el-table-column>
      </vm-table>
      <customer-address-edit ref="customerAddressModal" :customer-id="mainId" @save-success="getList()"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import CustomerAddressEdit from "./CustomerAddressEdit.vue";
  export default {
    name: "CustomerAddress",
    components: { VmTable, CustomerAddressEdit },
    props: {
      customerId: {
        type: [Number, String],
        default: "",
      },
    },
    data() {
      return {
        mainId: 0,
        selection: [],
      };
    },
    watch: {
      customerId: {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            this.mainId = newVal;
            this.$nextTick(() => {
              this.getList();
            });
          }
        },
      },
    },
    methods: {
      getList() {
        this.$refs.vmTable.getList(1);
      },

      // 单个删除
      oneDelete(pkid) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "customerDeliveryAddress", pkid).then((resp) => {
            if (resp.success) {
              this.$message.success("删除成功");
              this.getList(1);
            }
          });
        });
      },

      // 选中收货地址
      selectHandle(selection) {
        this.selection = selection;
      },

      // 批量删除
      deleteBatch() {
        var ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "customerDeliveryAddress/batchdelete", ids).then((resp) => {
            if (resp.success) {
              this.$message.success("删除成功");
              this.getList(1);
              this.selection = [];
            }
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
